"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _DictionaryTerm = _interopRequireDefault(require("./DictionaryTerm.modal"));

var _DictionaryTerms = require("./DictionaryTerms.api");

var _DictionaryTerms2 = _interopRequireDefault(require("./DictionaryTerms.context"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// DictionaryTermProvider for Brightcove player
var DictionaryTermProvider = function DictionaryTermProvider(_ref) {
  var children = _ref.children,
      productLineId = _ref.productLineId,
      theme = _ref.theme,
      baseApiUrl = _ref.baseApiUrl;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      dictionaryTerm = _useState2[0],
      setDictionaryTerm = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      dictionaryTerms = _useState4[0],
      setDictionaryTerms = _useState4[1];

  var dictionaryTermProviderRef = (0, _react.useRef)(null);

  var resetDictionaryTerm = function resetDictionaryTerm() {
    return setDictionaryTerm(null);
  };

  var handleDictionaryTermClick = (0, _react.useCallback)(function (element, e) {
    e.preventDefault();
    var modalContainer = document.createElement('div');
    var _element$dataset = element.dataset,
        height = _element$dataset.height,
        id = _element$dataset.id,
        dicTerm = _element$dataset.term,
        width = _element$dataset.width,
        innerText = element.innerText;
    var term = innerText.trim() || dicTerm;
    modalContainer.id = id;
    modalContainer.style.display = 'inline';
    element.appendChild(modalContainer);
    var parsedTerm = dictionaryTerms.find(function (_ref2) {
      var Term = _ref2.Term;
      return Term && Term.toLowerCase() === term.toLowerCase();
    }).Term.replaceAll(' ', '+');
    resetDictionaryTerm(null);
    setDictionaryTerm( /*#__PURE__*/_react["default"].createElement(_DictionaryTerm["default"], {
      elementId: id,
      endpoint: element.href,
      height: +height,
      term: parsedTerm,
      theme: theme,
      width: +width,
      baseApiUrl: baseApiUrl
    }));
  }, [baseApiUrl, dictionaryTerms, theme]);
  (0, _react.useEffect)(function () {
    var clicked = function clicked(e) {
      var event = e || window.event;
      var element = event.target || event.srcElement;

      while (element) {
        // eslint-disable-next-line no-undef
        if (element instanceof HTMLAnchorElement) {
          break;
        }

        element = element.parentNode;
      }

      if (element && element.classList.contains('ac-dictionary-term')) {
        handleDictionaryTermClick(element, e);
      }
    };

    window.addEventListener('click', clicked);
    return function () {
      window.removeEventListener('click', clicked);
    };
  }, [dictionaryTerms, theme, baseApiUrl, handleDictionaryTermClick]);
  (0, _react.useEffect)(function () {
    function fetchDictionaryTerms() {
      return _fetchDictionaryTerms.apply(this, arguments);
    }

    function _fetchDictionaryTerms() {
      _fetchDictionaryTerms = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _DictionaryTerms.getTerms)(productLineId, baseApiUrl);

              case 2:
                response = _context.sent;
                setDictionaryTerms(response);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchDictionaryTerms.apply(this, arguments);
    }

    fetchDictionaryTerms();
  }, [productLineId, theme, baseApiUrl]);

  if (!children) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: dictionaryTermProviderRef
  }, /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2["default"].Provider, {
    value: {
      dictionaryTerms: dictionaryTerms
    }
  }, children, dictionaryTerm));
};

DictionaryTermProvider.propTypes = {
  children: _propTypes.node.isRequired,
  productLineId: _propTypes.number.isRequired,
  theme: (0, _propTypes.shape)({}).isRequired,
  baseApiUrl: _propTypes.string
};
DictionaryTermProvider.defaultProps = {
  baseApiUrl: ''
};
DictionaryTermProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DictionaryTermProvider",
  "props": {
    "baseApiUrl": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "productLineId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "theme": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(DictionaryTermProvider);

exports["default"] = _default;